module.exports = __webpack_public_path__ + "img/icon-cashback.31e2f2a0.svg";